import "#styles/link.scss";
export interface Input extends Marko.Input<"a"> {}
<a ...input class=["a", input.class]>
  <${input.renderBody}/>
</a>
